import { render } from "./AddArtist.vue?vue&type=template&id=c6cb5512&scoped=true"
import script from "./AddArtist.vue?vue&type=script&lang=js"
export * from "./AddArtist.vue?vue&type=script&lang=js"

import "./AddArtist.vue?vue&type=style&index=0&id=c6cb5512&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6cb5512"]])

export default __exports__